export const getHostName = () =>
  `${window.location.protocol}//${window.location.hostname}`;
export const getUrloneParms = (id, url) => {
  const _url = url || window.location.href;
  if (_url.includes("?")) {
    let temp = _url.split("?")[1];
    let pram = new URLSearchParams("?" + temp);
    return String(pram.get(id)) && String(pram.get(id)) != "null"
      ? String(pram.get(id))
      : "";
  }
  return false;
};
//去除特殊字符~!@#$^-&*()=|{}':;',\[].<>/?~！@#￥……&*（）——|{}【】'；：""'。，、？
const  trimSpecial = (string) =>{
  if(string!= ""){
    const pattern=/[`~!@#$^\-&*()=|{}':;',\\\[\]\.<>\/?~！@#￥……&*（）——|{}【】'；：""'。，、？\s]/g;
    string = string.replace(pattern,"");
  }
  return string
}

export default {
  getUrloneParms,
  trimSpecial,
  getHostName
}